<ng-container formGroupName="profiles">
    <label class="container">
        <div>
            <div
                style="
                    display: flex;
                    align-items: center;
                    color: #82c940;
                    gap: 7px;
                "
            >
                <div style="font-weight: bold; font-size: 16; white-space: nowrap;">
                    {{ label }}
                </div>
                <div style="font-weight: 300; font-size: 14px">
                    ({{ code }})
                </div>
                <div *ngIf="stared">★</div>
            </div>
        </div>
        <input [formControlName]="name" type="checkbox" />
        <span class="checkmark"></span>
    </label>
    <div style="margin-left: 30px; margin-top: -5px;margin-bottom: 8px;">
        <ng-content></ng-content>
    </div>
</ng-container>
